import PropTypes from 'prop-types';

export const EventTileGroupStandard = (props) => {
  const { children } = props;
  return children?.map((child, index) => (
    <div
      className="event-tile-col col-sm-4"
      key={index}
      data-testid="standard-tile"
    >
      {child}
    </div>
  ));
};

EventTileGroupStandard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
